<div class="top">
    <div class="heading">
        <span class="fw-bold">EDIT ASSET DETAILS</span>
    </div>
    <i class="material-icons text-danger" role="button" (click)="closeModal()">
        close
    </i>
</div>

<div class="form-wrapper">

    <div class="row gx-2 gy-3">
        <div class="col-sm-4">
            <div class="image-wrapper">
                <input type="file" #assetImageInput accept="image/*" hidden="true"
                    (change)="onAssetImageChange($event)">
                <div class="image">
                    <div class="image-placeholder" (click)="triggerUploadAssetImage()"
                        *ngIf="!assetImageControl?.value">
                        <svg width="33" height="29" viewBox="0 0 33 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.2"
                                d="M29.735 4.11181H24.8606L22.4438 0.485786C22.3843 0.396597 22.3038 0.32344 22.2093 0.272778C22.1148 0.222117 22.0093 0.195511 21.9021 0.195312H11.4581C11.3508 0.195511 11.2453 0.222117 11.1508 0.272778C11.0563 0.32344 10.9758 0.396597 10.9163 0.485786L8.49621 4.11181H3.62507C2.75947 4.11181 1.92933 4.45567 1.31726 5.06774C0.705186 5.67981 0.361328 6.50995 0.361328 7.37555V25.6525C0.361328 26.5181 0.705186 27.3483 1.31726 27.9603C1.92933 28.5724 2.75947 28.9163 3.62507 28.9163H29.735C30.6006 28.9163 31.4308 28.5724 32.0429 27.9603C32.6549 27.3483 32.9988 26.5181 32.9988 25.6525V7.37555C32.9988 6.50995 32.6549 5.67981 32.0429 5.06774C31.4308 4.45567 30.6006 4.11181 29.735 4.11181ZM31.6933 25.6525C31.6933 26.1719 31.487 26.67 31.1197 27.0372C30.7525 27.4045 30.2544 27.6108 29.735 27.6108H3.62507C3.10571 27.6108 2.60763 27.4045 2.24038 27.0372C1.87314 26.67 1.66683 26.1719 1.66683 25.6525V7.37555C1.66683 6.85619 1.87314 6.35811 2.24038 5.99086C2.60763 5.62362 3.10571 5.41731 3.62507 5.41731H8.84707C8.95456 5.41738 9.06041 5.3909 9.15521 5.34022C9.25001 5.28955 9.33082 5.21625 9.39048 5.12683L11.8057 1.50081H21.5512L23.9696 5.12683C24.0293 5.21625 24.1101 5.28955 24.2049 5.34022C24.2997 5.3909 24.4056 5.41738 24.513 5.41731H29.735C30.2544 5.41731 30.7525 5.62362 31.1197 5.99086C31.487 6.35811 31.6933 6.85619 31.6933 7.37555V25.6525ZM16.6801 9.3338C15.389 9.3338 14.127 9.71663 13.0536 10.4339C11.9801 11.1511 11.1435 12.1706 10.6494 13.3633C10.1554 14.5561 10.0261 15.8685 10.278 17.1347C10.5299 18.401 11.1515 19.564 12.0644 20.4769C12.9773 21.3898 14.1404 22.0115 15.4066 22.2634C16.6728 22.5152 17.9853 22.386 19.178 21.8919C20.3708 21.3979 21.3902 20.5612 22.1075 19.4878C22.8247 18.4143 23.2076 17.1523 23.2076 15.8613C23.2076 14.1301 22.5198 12.4698 21.2957 11.2457C20.0715 10.0215 18.4113 9.3338 16.6801 9.3338ZM16.6801 21.0833C15.6472 21.0833 14.6376 20.777 13.7789 20.2032C12.9201 19.6294 12.2508 18.8139 11.8556 17.8597C11.4603 16.9055 11.3569 15.8555 11.5584 14.8425C11.7599 13.8296 12.2572 12.8991 12.9876 12.1688C13.7179 11.4385 14.6483 10.9411 15.6613 10.7396C16.6743 10.5381 17.7242 10.6416 18.6784 11.0368C19.6326 11.432 20.4482 12.1014 21.022 12.9601C21.5958 13.8189 21.9021 14.8285 21.9021 15.8613C21.9021 17.2463 21.3519 18.5745 20.3726 19.5538C19.3932 20.5331 18.065 21.0833 16.6801 21.0833Z"
                                fill="black" />
                        </svg>
                        <span class="text-decoration-underline">UPLOAD IMAGE</span>
                    </div>
                    <div class="uploaded-image" *ngIf="assetImageControl?.value">

                        <img [src]="assetImageControl?.value?.readableUrl" alt="image_upload"
                            >

                        <span (click)="triggerUploadAssetImage()" class="replace-image-btn"><svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M17.5753 7.23379C17.5753 6.35069 17.7448 5.50543 18.0316 4.71064H7.14631C6.45483 4.71064 5.79166 4.97647 5.30271 5.44966C4.81375 5.92284 4.53906 6.56461 4.53906 7.23379V24.8958C4.53906 26.2835 5.71232 27.4189 7.14631 27.4189H25.3971C26.0885 27.4189 26.7517 27.1531 27.2407 26.6799C27.7296 26.2068 28.0043 25.565 28.0043 24.8958V14.3617C27.183 14.6392 26.3096 14.8032 25.3971 14.8032V24.8958H7.14631V7.23379H17.5753Z"
                                    fill="white" />
                                <path
                                    d="M25.3597 11.687V8.63387H28.5147V6.59845H25.3597V3.54531H23.2565V6.59845H20.1016V8.63387H23.2565V11.687H25.3597Z"
                                    fill="white" />
                                <path
                                    d="M15.2468 22.5539L18.8317 18.0879L24.6707 24.0299H18.0365H8.19531L12.6917 19.5765L15.2468 22.5539Z"
                                    fill="white" />
                            </svg>
                        </span>
                    </div>
                </div>
                <app-error-message [form]="form" controlName="assetImage" [showErrorMessage]="true"
                    label="Asset Image"></app-error-message>
            </div>
        </div>
        <div class="col-sm-8">
            <form [formGroup]="form" (ngSubmit)="openConfirmModal()">
                <div class="form-fields">
                    <div class="row g-3">
                        <div class="col-md-12 field">
                            <label class="required">
                                TYPE
                            </label>
                            <ng-select [items]="propertyTypeList" [multiple]="false" [closeOnSelect]="true"
                                [searchable]="true" [hideSelected]="false" bindLabel="formattedName" bindValue="id"
                                placeholder="Select" formControlName="type" class="ng-select control role-select">
                            </ng-select>
                            <app-error-message [form]="form" controlName="type"
                                [showErrorMessage]="showErrorMessages"></app-error-message>
                        </div>
                        <div class="col-md-12 field">
                            <label class="required">
                                CATEGORY
                            </label>
                            <ng-select [items]="propertyCategoryList" [multiple]="false" [closeOnSelect]="true"
                                [searchable]="true" [hideSelected]="false" bindLabel="formattedName" bindValue="id"
                                placeholder="Select" formControlName="category" class="ng-select control role-select">
                            </ng-select>
                            <app-error-message [form]="form" controlName="category"
                                [showErrorMessage]="showErrorMessages"></app-error-message>
                        </div>
                        <div class="col-md-12 field">
                            <label>
                                FULL ADDRESS
                            </label>
                            <input type="text" placeholder="-- Upper Iweka --" class="form-control mt-0"
                                formControlName="address" maxlength="100">
                            <app-error-message [form]="form" controlName="address"
                                [showErrorMessage]="showErrorMessages"></app-error-message>
                        </div>
                    </div>
                </div>
                <div class="modal-actions-wrapper">
                    <button type="submit" class="custom-btn-primary w-100"
                        [disabled]="!form.dirty || form.invalid || isSubmitting">
                        <ng-container *ngIf="!isSubmitting; else loadingTemplate">
                            <span>Save & Continue</span>
                        </ng-container>
                        <ng-template #loadingTemplate>
                            <span>Saving, please wait...</span>
                            <div class="spinner-light"></div>
                        </ng-template>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>